export type FormatAction = 'bold' | 'italic' | 'heading' | 'list' | 'quote' | 'link'

export interface SelectionResult {
  value: string
  selectionStart: number
  selectionEnd: number
}

export function formatSelection(
  value: string,
  rawStart: number,
  rawEnd: number,
  action: FormatAction,
): SelectionResult {
  const start = Math.max(0, rawStart)
  const end = Math.max(start, rawEnd)
  const selected = value.slice(start, end)

  if (action === 'bold' || action === 'italic') {
    const marker = action === 'bold' ? '**' : '_'
    return {
      value: `${value.slice(0, start)}${marker}${selected}${marker}${value.slice(end)}`,
      selectionStart: start + marker.length,
      selectionEnd: end + marker.length,
    }
  }

  if (action === 'link') {
    const label = selected || '链接文字'
    const prefix = '['
    const suffix = '](https://)'
    return {
      value: `${value.slice(0, start)}${prefix}${label}${suffix}${value.slice(end)}`,
      selectionStart: start + prefix.length,
      selectionEnd: start + prefix.length + label.length,
    }
  }

  const lineStart = value.lastIndexOf('\n', start - 1) + 1
  const lineEndMatch = value.indexOf('\n', end)
  const lineEnd = lineEndMatch === -1 ? value.length : lineEndMatch
  const block = value.slice(lineStart, lineEnd)
  const prefix = action === 'heading' ? '## ' : action === 'quote' ? '> ' : '- '
  const transformed = action === 'heading' ? `${prefix}${block}` : block.split('\n').map((line) => `${prefix}${line}`).join('\n')
  const prefixesBeforeEnd = action === 'heading' ? 1 : block.slice(0, Math.max(0, end - lineStart)).split('\n').length
  return {
    value: `${value.slice(0, lineStart)}${transformed}${value.slice(lineEnd)}`,
    selectionStart: start + prefix.length,
    selectionEnd: end + prefix.length * prefixesBeforeEnd,
  }
}

export function countDocumentUnits(value: string): number {
  const cjk = value.match(/[\p{Script=Han}\p{Script=Hiragana}\p{Script=Katakana}\p{Script=Hangul}]/gu)?.length ?? 0
  const nonCjkWords = value
    .replace(/[\p{Script=Han}\p{Script=Hiragana}\p{Script=Katakana}\p{Script=Hangul}]/gu, ' ')
    .trim()
    .split(/\s+/u)
    .filter(Boolean).length
  return cjk + nonCjkWords
}
